import {
  ArrayInput,
  FormDataConsumer,
  SelectInput,
  SimpleFormIterator,
  TextInput,
} from "react-admin";
import Typography from "@mui/material/Typography";
import NoArrowKeyNumberInput from "@/components/NoArrowKeyNumberInput";

const typeChoices = [
  { id: "NIYAAZ_FORM", name: "Niyaaz form" },
  { id: "NIYAAZ_RECEIPT", name: "Niyaaz receipt" },
];

export const EventSequenceFields = () => (
  <>
    <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1, mb: 0.5 }}>
      Number sequences
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
      Configure form and receipt counters for this event. Add one receipt row and one form row per
      jaman venue.
    </Typography>
    <ArrayInput source="sequences" label={false}>
      <SimpleFormIterator inline>
        <SelectInput source="type" label="Type" choices={typeChoices} />
        <FormDataConsumer>
          {({ scopedFormData }) =>
            scopedFormData?.type === "NIYAAZ_FORM" ? (
              <TextInput source="venueCode" label="Venue code" helperText="Jaman code e.g. JM" />
            ) : null
          }
        </FormDataConsumer>
        <TextInput source="prefix" label="Prefix" />
        <NoArrowKeyNumberInput source="currentValue" label="Current" defaultValue={0} />
      </SimpleFormIterator>
    </ArrayInput>
  </>
);
